<template>
  <v-container class="d-flex justify-center">
    <v-alert outlined type="info" border="bottom">
      {{ empleadoNoRegistradoMensaje }} con la identificacion
      <span class="font-weight-bold">{{ identificacionInput }}</span>
    </v-alert>
  </v-container>
</template>

<script>
export default {
  name: 'EmpleadoNoRegistradoAlert',
  props: {
    empleadoNoRegistradoMensaje: {
      type: String,
      required: true,
    },
    identificacionInput: {
      type: String,
      required: true,
    },
  },
};
</script>
